/* eslint-disable react/prop-types */
import { Link } from "react-router-dom";

const UPDATED = "16 September 2026";

function Section({ title, children }) {
  return (
    <section className="space-y-3 border-t border-black/10 pt-7">
      <h2 className="font-kalice text-2xl font-medium sm:text-3xl">{title}</h2>
      <div className="space-y-3 text-sm leading-relaxed text-black/70 sm:text-base">
        {children}
      </div>
    </section>
  );
}

export default function MembershipTerms() {
  return (
    <main className="mx-auto w-full max-w-3xl px-5 py-16 font-sans sm:py-24">
      <header className="mb-12 space-y-5">
        <p className="text-xs uppercase tracking-[0.18em] text-black/45">Legal</p>
        <h1 className="font-kalice text-5xl font-medium leading-none sm:text-6xl">
          Membership Terms
        </h1>
        <p className="text-sm text-black/50">Last updated {UPDATED}</p>
        <p className="max-w-2xl text-base leading-relaxed text-black/70 sm:text-lg">
          These terms govern your Antoia member account and personal
          collection. They form an agreement between you and Cypherloom B.V.,
          trading as Antoia (“Antoia”, “we”, or “us”).
        </p>
      </header>

      <div className="space-y-10">
        <Section title="1. Your membership">
          <p>
            Membership gives you access to a personal Antoia space where
            experiences and pieces connected to you can be saved and revisited.
            A membership may be created after you claim an experience, receive
            an invitation, or otherwise register with us. Membership is
            currently free and does not require you to receive promotional
            email.
          </p>
          <p>
            These terms concern membership and digital experiences. Separate
            terms may apply if Antoia later offers products, commissions, paid
            events, or other purchases.
          </p>
        </Section>

        <Section title="2. Your account">
          <p>
            You must provide accurate information and use only an email address
            you are entitled to access. Sign-in links are personal. Keep them
            secure and tell us promptly if you believe someone else has used
            your account.
          </p>
          <p>
            If you are not legally able to agree to these terms yourself, a
            parent or legal guardian must do so with you. Visitors under 16
            should not opt in to promotional messages without the involvement
            of a parent or guardian.
          </p>
        </Section>

        <Section title="3. Your collection and public links">
          <p>
            Your member collection is private to your signed-in account unless
            a creation has a public share page. A Trionfi card’s share page can
            be opened by anyone with its link, and cards may appear without a
            personal share link in a public visual overview. Do not share a
            card link if you do not want others to see that page.
          </p>
          <p>
            We may correct, update, archive, or remove a creation or public
            page where reasonably necessary, including for safety, cultural
            care, legal compliance, or the integrity of the experience.
          </p>
        </Section>

        <Section title="4. Creative work and contributions">
          <p>
            Antoia and its licensors retain rights in the service, software,
            visual systems, card designs, texts, and other creative material.
            You retain any rights you have in original material you submit.
            You give us permission to process, adapt, store, and display your
            contributions as needed to create and provide the experience and
            its public share page.
          </p>
        </Section>

        <Section title="5. Artistic and interpretive experiences">
          <p>
            Trionfi and related works are artistic and research experiences.
            Their symbols, archetypes, and generated interpretations are not
            professional, medical, psychological, legal, or financial advice,
            and should not be treated as factual assessments or predictions.
            Designs and text may change as we refine the work and respond to
            cultural context or feedback.
          </p>
        </Section>

        <Section title="6. Acceptable use">
          <p>
            Do not misuse the service, attempt to access another person’s
            account, interfere with security or operation, upload unlawful or
            harmful material, or use Antoia’s work in a way that infringes
            another person’s rights. We may restrict access where reasonably
            necessary to protect people, the service, or our legal obligations.
          </p>
        </Section>

        <Section title="7. Email choices">
          <p>
            We may send essential messages needed for sign-in, security,
            support, your creations, and material changes to the membership
            service. Invitations, editorial updates, offers, and announcements
            are optional. We send those only according to your recorded choice,
            which you can change or withdraw at any time.
          </p>
        </Section>

        <Section title="8. Availability and responsibility">
          <p>
            We aim to keep Antoia available and secure, but a digital or
            experimental service may occasionally change, pause, or contain an
            error. Where permitted by law, we are not responsible for indirect
            or unforeseeable loss caused by use of a free artistic experience.
            Nothing in these terms excludes liability or consumer rights that
            cannot lawfully be excluded.
          </p>
        </Section>

        <Section title="9. Ending membership">
          <p>
            You may ask us to close your account. We may suspend or end access
            for serious or repeated breach of these terms, unlawful use, or
            where the service is discontinued. Privacy and legal retention
            obligations may require us to keep limited records after an account
            closes.
          </p>
        </Section>

        <Section title="10. Changes and applicable law">
          <p>
            We may update these terms as Antoia develops. We will give
            appropriate notice of material changes and may ask you to accept a
            new version before continuing. Dutch law applies. Any mandatory
            consumer protections and competent courts remain unaffected.
          </p>
        </Section>

        <Section title="Contact">
          <p>
            Cypherloom B.V., trading as Antoia
            <br />
            Sint-Agathastraat 54, unit 0.16
            <br />
            3037 SH Rotterdam, the Netherlands
            <br />
            <a className="underline underline-offset-4" href="mailto:hello@antoia.com">
              hello@antoia.com
            </a>
          </p>
        </Section>
      </div>

      <div className="mt-14 border-t border-black/10 pt-7 text-sm">
        <Link className="underline underline-offset-4" to="/privacy">
          Read the Antoia Privacy Notice
        </Link>
      </div>
    </main>
  );
}
